import { FormEvent, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import ButtonLoader from '../../../common/ButtonLoader';
import { isFormValidated } from '../../../../utils/formUtils';

function PopupModal() {
  const [isLoading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const closeModal = () => {
    setOpen(!open);
  };
  const sendDataAsync = async (event: FormEvent) => {
    if (!isFormValidated('email-form')) {
      return;
    }
    event.preventDefault();

    const email = (document.getElementById('email') as HTMLInputElement).value!;
    const name = (document.getElementById('name') as HTMLInputElement).value;
    const phoneNumber = ''; //document.getElementById("phone-number").value;
    const company = (document.getElementById('company') as HTMLInputElement).value;
    // const jobRole = '';

    // const industry1 = '';
    // const industry2 = '';

    const emailParts = email.split('@');

    if (emailParts.length < 2) {
      alert('Please enter a valid email');
      return;
    }

    (document.getElementById('entry.22219071') as HTMLInputElement).value = name;
    (document.getElementById('entry.1247612596') as HTMLInputElement).value = phoneNumber;
    (document.getElementById('entry.1861582534') as HTMLInputElement).value = email;
    (document.getElementById('entry.161741310') as HTMLInputElement).value = company;

    // if (industry2 !== '') {
    //   (document.getElementById('entry.399333315.other_option_response').value = industry2;
    // }

    try {
      // Create iframe for form submission
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      // Submit form to the iframe
      const form = document.getElementById('email-form') as HTMLFormElement;
      const formData = new FormData(form);
      await fetch(form.action, {
        method: 'POST',
        body: formData,
        mode: 'no-cors',
      })
        .then((response) => {
          //   console.log(response);
          //   if (response.ok === false) {
          //     throw new Error(response.statusText);
          //   }
          setTimeout(() => {
            window.location.href =
              'https://drive.google.com/file/d/1-TeTp0zapi_rwP7lB0PWU-q6cnCJqGUJ/view?usp=sharing';
          }, 1500);
        })
        .catch((err) => {
          alert(err);
        })
        .finally(() => {
          setLoading(false);
        });

      // After short delay, hide modal and show calculator
    } catch (error) {
      console.error('Form submission error:', error);
      alert('An error occured when submitting your form');
      // Still show calculator even if submission fails
      //   popupModal.hide();
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setOpen(true);
    }, 5000);
  }, []);
  return (
    <Modal show={open} onHide={closeModal} size='lg' backdrop={isLoading ? 'static' : true}>
      <Modal.Header closeButton>
        <Modal.Title>The Infrastructure Behind Embedded Healthcare</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='content-bg position-relative'>
          <div className='d-flex justify-content-center'>
            <div className='col-md-8 position-absolute p-3 bg-white' style={{ bottom: ' 0' }}>
              <h5 className='modal-title fs-36 fw-600' style={{ lineHeight: '45px' }}>
                The Infrastructure Behind Embedded Healthcare
              </h5>
              <div className='fs-18 mt-3' style={{ lineHeight: '25px' }}>
                See how embedded healthcare works at scale in Nigeria—{' '}
                <strong>3,000+ pharmacies, 36 states, ₦1 billion in transactions</strong>.
                <div className='mt-4'>
                  Inside: network distribution, partner economics, fulfillment metrics, and
                  integration pathways.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row justify-content-center'>
          <form
            id='email-form'
            className='mt-5 col-md-8'
            method='POST'
            action='https://docs.google.com/forms/d/e/1FAIpQLSd9wgP-polA_gks1qVJIiNp0rDI58y6epxLK4dU3aOJGno0iw/formResponse'
          >
            <fieldset disabled={isLoading}>
              <input type='hidden' name='entry.22219071' id='entry.22219071' />
              <input type='hidden' name='entry.161741310' id='entry.161741310' />
              <input type='hidden' name='entry.1861582534' id='entry.1861582534' />
              <input type='hidden' name='entry.1247612596' id='entry.1247612596' />
              <div className='mb-3'>
                <label htmlFor='name' className='form-label'>
                  Name <span className='text-danger'>*</span>
                </label>
                <input type='text' className='form-control' id='name' required />
              </div>

              <div className='mb-3'>
                <label htmlFor='email' className='form-label'>
                  Work Email <span className='text-danger'>*</span>
                </label>
                <input type='email' className='form-control' id='email' required />
              </div>

              <div className='mb-3'>
                <label htmlFor='company' className='form-label'>
                  Company Name <span className='text-danger'>*</span>
                </label>
                <input type='text' className='form-control' id='company' required />
              </div>
              <div className='text-center mt-4 d-flex justify-content-center'>
                <button type='submit' className='btn btn-primary col-md-6' onClick={sendDataAsync}>
                  Download now {isLoading && <ButtonLoader />}
                </button>
              </div>
            </fieldset>
          </form>
        </div>
        {/* <fieldset disabled={isLoading}>
            <div className='row'>
              <div className='form-group col-sm-4 mt-2'>
                <label>Full name</label>
                <input
                  type='text'
                  className='form-control'
                  //   value={pharmacyData.pharmacyName}
                  //   onChange={handlePharmacyChange('pharmacyName')}
                  required
                />
              </div>
            </div>
          </fieldset> */}
      </Modal.Body>
    </Modal>
  );
}

export default PopupModal;
